/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Fit_Single_Line_LabelInputs */



/**
* | output |
* | --- |
* | "Fit Single Line" |
*
* @param {Style_Guide_Manager_Fit_Single_Line_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_fit_single_line_label = /** @type {((inputs?: Style_Guide_Manager_Fit_Single_Line_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Fit_Single_Line_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Adapter a une seule ligne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Passt für Einzelleitungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Adatta la linea singola")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подгонка по одной линии")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ajuste de línea única")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("适合单线")
	if (locale === "ja") return /** @type {LocalizedString} */ ("単一行に合わせる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सिंगल लाइन फिट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ajuste de linha única")
	return /** @type {LocalizedString} */ ("Fit Single Line")
});